module.exports = __webpack_public_path__ + "img/commande client.5529ad97.png";